module.exports = __WEBPACK_EXTERNAL_MODULE_3__;


//////////////////
// WEBPACK FOOTER
// external "ecCom"
// module id = 3
// module chunks = 66